import gql from 'graphql-tag';

import { YearbookPhotoDetails } from '../fragments/yearbook-photos';

export const yearbookPhotosSet = gql`
  mutation yearbookPhotosSet($input: YearbookPhotosSetInput!) {
    yearbookPhotosSet(input: $input) {
      success
      yearbook_photos {
        ...YearbookPhotoDetails
      }
    }
  }
  ${YearbookPhotoDetails}
`;

export const yearbookPhotoDelete = gql`
  mutation yearbookPhotoDelete($input: YearbookPhotoDeleteInput!) {
    yearbookPhotoDelete(input: $input) {
      success
    }
  }
`;
